export const getSelectedExtraProducts = (state) => state.extraProducts.selected;
export const getExtraProducts = (state) => state.extraProducts.extraProducts;
export const getExtraProductsFetchStatus = (state) => state.extraProducts.fetchStatus;
export const getPreOptedAncillaries = (state) => state.extraProducts.preOptedAncillaries;
export const getExtraProductsPageLoadTime = (state) => state.extraProducts.pageLoadTime;
